var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeAsterisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 595.28",
    enableBackground: "new 0 0 595.28 595.28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F26423",
    cx: 297.64,
    cy: 297.64,
    r: 290.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M348.42,107.19l-16.02,143.75l145.7-40.62L491,308.75l-132.81,9.38l87.11,116.02l-88.67,47.27 l-60.94-122.27l-53.52,121.48l-92.19-46.48l86.33-116.02l-132.03-10.16l15.23-97.66l142.58,40.62l-16.02-143.75H348.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeAsterisk);
export default __webpack_public_path__ + "static/media/orange-asterisk.2894bde2fe955a1f16be0ecb7fd43aed.svg";
export { ForwardRef as ReactComponent };